import axios, { AxiosInstance } from 'axios';
import environment from '../environment';

const aemClient: AxiosInstance = axios.create({
    baseURL: environment.AEM_URL ? environment.AEM_URL : 'https://contentqa.fordpro.com',
});

export default aemClient;
